'use strict';

var ResourceFactory = require('../Factory');
var Validate = require('../../core').Validate;

var definition = {
  name: 'ProjectUser',
  basePath: ':basePath',
  endpoint: 'projects',
  debug: false,
  methods: null,
  relations: {
    hasOne: {
      Project: {
        localField: 'project',
        foreignKey: 'projectId'
      },
      User: {
        localField: 'user',
        foreignKey: 'userId'
      }
    }
  }
};

var ProjectUserResource = function(DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
};

var getResourceOptions = function(options) {

  Validate.exists(options, 'fbBaseUri');
  Validate.exists(options, 'fbAuthToken');

  return {
    name : 'ProjectUser',
    apiBaseUri: options.apiBaseUri,
    collectionMethods: {
      get: function (id, params, options) {
        var DS = this.$DS;

        options = options || {};
        options.endpoint = 'projects/{{projectId}}/users';

        return DS.find.call(DS, this.$name, id, params, options);
      },
      findAll: function (params, options) {

        var DS = this.$DS;

        options = options || {};
        options.endpoint = 'projects/{{projectId}}/users';

        return DS.findAll.call(DS, this.$name, params, options);
      },
      destroy: function (id, options) {
        var DS = this.$DS;
        options = options || {};
        options.endpoint = 'projects/{{projectId}}/users';

        return DS.destroy.call(DS, this.$name, id, options);
      }
    },

    modelMethods: {},

    group: true,

    hooks: {},

    // definition formatted and passed to js-data DS
    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri,
        name : 'ProjectUser'
      }
    },

    syncTriggers: {}
  };
};

module.exports = ProjectUserResource;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/project/ProjectUserResource.js